import { trackConversion } from '../components/GoogleAnalytics';

export const openWhatsAppQuote = (serviceName?: string) => {
  const phoneNumber = '918466055207';
  const message = encodeURIComponent(
    serviceName 
      ? `Hi! I would like to get a quote for ${serviceName} installation. Please provide me with more information.`
      : 'Hi! I would like to get a quote for safety nets installation. Please provide me with more information.'
  );
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
  
  // Track conversion in Google Analytics
  trackConversion('whatsapp_quote_click', serviceName);
  
  // Open WhatsApp in new tab/window
  window.open(whatsappUrl, '_blank');
};
